export default __webpack_public_path__ + "static/media/alertPoster.976ef457.jpg";